function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.2868 8.57255H46.2868V4.00112C46.2868 3.68683 46.0297 3.42969 45.7154 3.42969H41.7154C41.4011 3.42969 41.144 3.68683 41.144 4.00112V8.57255H22.8583V4.00112C22.8583 3.68683 22.6011 3.42969 22.2868 3.42969H18.2868C17.9725 3.42969 17.7154 3.68683 17.7154 4.00112V8.57255H5.7154C4.45112 8.57255 3.42969 9.59397 3.42969 10.8583V58.2868C3.42969 59.5511 4.45112 60.5726 5.7154 60.5726H58.2868C59.5511 60.5726 60.5726 59.5511 60.5726 58.2868V10.8583C60.5726 9.59397 59.5511 8.57255 58.2868 8.57255ZM55.4297 55.4297H8.57255V28.2868H55.4297V55.4297ZM8.57255 23.4297V13.7154H17.7154V17.144C17.7154 17.4583 17.9725 17.7154 18.2868 17.7154H22.2868C22.6011 17.7154 22.8583 17.4583 22.8583 17.144V13.7154H41.144V17.144C41.144 17.4583 41.4011 17.7154 41.7154 17.7154H45.7154C46.0297 17.7154 46.2868 17.4583 46.2868 17.144V13.7154H55.4297V23.4297H8.57255Z",
  fill: "black"
});

var SvgPlan = function SvgPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plan.cbdfc05b.svg";
export { ForwardRef as ReactComponent };